import mark from './mark';
import measure from './measure';
import measureAndLog from './measureAndLog';
import markRouteChange from './markRouteChange';
import { markSpaNavigationStart } from './spaNavigationStart';
import useMeasureRenderFromNavigationStart from './useMeasureRenderFromNavigationStart';

const metricsLoggingEnabled = localStorage.getItem('perf-metrics') === '1';
if (metricsLoggingEnabled) {
  // eslint-disable-next-line no-console
  console.info(
    `%c[HJ-PERFORMANCE] If you don't want to see performance metrics, you can disable them by running localStorage.setItem('perf-metrics', 0)`,
    'color: orange; font-weight: bold;',
  );
}

export {
  mark,
  measure,
  measureAndLog,
  markRouteChange,
  markSpaNavigationStart,
  useMeasureRenderFromNavigationStart,
};
